"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activeYzhConf = activeYzhConf;
exports.deleteKapayerBook = deleteKapayerBook;
exports.deleteTransferAccount = deleteTransferAccount;
exports.deleteYzhConf = deleteYzhConf;
exports.editAlipayAccountNumber = editAlipayAccountNumber;
exports.editTransferAccount = editTransferAccount;
exports.queryAlipayAccountNumber = queryAlipayAccountNumber;
exports.queryKapayerBookDetail = queryKapayerBookDetail;
exports.queryKapayerBookList = queryKapayerBookList;
exports.queryTenantBizConfig = queryTenantBizConfig;
exports.queryTransferAccountDetail = queryTransferAccountDetail;
exports.queryTransferAccountPage = queryTransferAccountPage;
exports.queryYzhConfDetail = queryYzhConfDetail;
exports.queryYzhConfPage = queryYzhConfPage;
exports.saveKapayerBook = saveKapayerBook;
exports.saveTenantBizConfig = saveTenantBizConfig;
exports.saveYzhConf = saveYzhConf;
exports.saveYzhConfKey = saveYzhConfKey;
exports.setDefaultTransferAccount = setDefaultTransferAccount;
exports.syncKapayerBookBalance = syncKapayerBookBalance;
exports.syncYzhConfBalance = syncYzhConfBalance;
var _request = _interopRequireDefault(require("@/utils/request"));
function queryAlipayAccountNumber(params) {
  return (0, _request.default)({
    url: '/portal/system/tradeAccount/queryAlipayAccountNumber',
    method: 'get',
    params: params
  });
}
function editAlipayAccountNumber(data) {
  return (0, _request.default)({
    url: '/portal/system/tradeAccount/editAlipayAccountNumber',
    method: 'post',
    data: data
  });
}
function queryTransferAccountPage(data) {
  return (0, _request.default)({
    url: '/portal/system/tradeAccount/queryTransferAccountPage',
    method: 'post',
    data: data
  });
}
function editTransferAccount(data) {
  return (0, _request.default)({
    url: '/portal/system/tradeAccount/editTransferAccount',
    method: 'post',
    data: data
  });
}
function setDefaultTransferAccount(data) {
  return (0, _request.default)({
    url: '/portal/system/tradeAccount/setDefaultTransferAccount',
    method: 'post',
    data: data
  });
}
function deleteTransferAccount(data) {
  return (0, _request.default)({
    url: '/portal/system/tradeAccount/deleteTransferAccount',
    method: 'post',
    data: data
  });
}
function queryTransferAccountDetail(data) {
  return (0, _request.default)({
    url: '/portal/system/tradeAccount/queryTransferAccountDetail',
    method: 'post',
    data: data
  });
}
/** 查询租户业务配置 */
function queryTenantBizConfig(params) {
  return (0, _request.default)({
    url: '/portal/system/tenant/bizconfig/query',
    method: 'get',
    params: params
  });
}
/** 保存租户业务配置 */
function saveTenantBizConfig(data) {
  return (0, _request.default)({
    url: '/portal/system/tenant/bizconfig/save',
    method: 'post',
    data: data
  });
}
/** 分页查询快安支付记账本 */
function queryKapayerBookList(params) {
  return (0, _request.default)({
    url: '/portal/system/kapayerbook/list',
    method: 'get',
    params: params
  });
}
/** 保存/设为使用快安支付记账本 operateType: 1 新增或修改、2 设为使用 */
function saveKapayerBook(data) {
  return (0, _request.default)({
    url: '/portal/system/kapayerbook/save',
    method: 'post',
    data: data
  });
}
/** 删除快安支付记账本 */
function deleteKapayerBook(data) {
  return (0, _request.default)({
    url: '/portal/system/kapayerbook/delete',
    method: 'post',
    data: data
  });
}
/** 同步快安支付记账本余额 */
function syncKapayerBookBalance(data) {
  return (0, _request.default)({
    url: '/portal/system/kapayerbook/syncbalance',
    method: 'post',
    data: data
  });
}
/** 查询快安支付记账本详情 */
function queryKapayerBookDetail(params) {
  return (0, _request.default)({
    url: '/portal/system/kapayerbook/detail',
    method: 'get',
    params: params
  });
}
/** 分页查询云账户配置列表 */
function queryYzhConfPage(params) {
  return (0, _request.default)({
    url: '/portal/system/yzhconf',
    method: 'get',
    params: params
  });
}
/** 启用云账户配置（设为使用） */
function activeYzhConf(data) {
  return (0, _request.default)({
    url: '/portal/system/yzhconf/active',
    method: 'post',
    data: data
  });
}
/** 同步云账户余额 */
function syncYzhConfBalance(data) {
  return (0, _request.default)({
    url: '/portal/system/yzhconf/balance',
    method: 'post',
    data: data
  });
}
/** 删除云账户配置 */
function deleteYzhConf(data) {
  return (0, _request.default)({
    url: '/portal/system/yzhconf/delete',
    method: 'post',
    data: data
  });
}
/** 查询云账户配置详情 */
function queryYzhConfDetail(params) {
  return (0, _request.default)({
    url: '/portal/system/yzhconf/detail',
    method: 'get',
    params: params
  });
}
/** 保存云账户平台企业密钥（公私钥均不传时新生成密钥对） */
function saveYzhConfKey(data) {
  return (0, _request.default)({
    url: '/portal/system/yzhconf/key',
    method: 'post',
    data: data
  });
}
/** 保存/更新云账户配置（confId 有值时更新，为空时新增） */
function saveYzhConf(data) {
  return (0, _request.default)({
    url: '/portal/system/yzhconf/saveOrUpdate',
    method: 'post',
    data: data
  });
}